import { render, staticRenderFns } from "./ExportAddPagesConfig.vue?vue&type=template&id=92b21bdc"
import script from "./ExportAddPagesConfig.vue?vue&type=script&lang=js"
export * from "./ExportAddPagesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports